import React from 'react';


const Step1 = (props) => {
    return (
        <div id="step-one" className="step-1-container question-step">
            <div className="step-title_container">
                <div className="step-number">
                    01.
                </div>
                <div>
                    <h2 className="question-title">Tell Us The Amount and Type of Loan You Need.</h2>
                    <hr className="question-title_line"/>
                    <div className="step-1_form clearfix">
                        {
                            props.questions.map((q, i) => {
                                if (i >= props.start && i <= props.end) {
                                    return props.renderQuestion(q, i)
                                }

                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Step1;
